import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import { Header } from './components/Header';
import { PersonalPage } from './pages/PersonalPage';
import { ReservationPage } from './pages/ReservationPage';
import { SetupPage } from './pages/SetupPage';
import { DataProvider } from './context/DataContext';
import { ConfirmationProvider } from './context/ConfirmationContext';
import { NotificationProvider } from './context/NotificationContext';
import { AlertProvider } from './context/AlertContext'; // Import new provider
import { LoginOverlay } from './components/LoginOverlay';
import { User } from './types';
import * as api from './services/mockAPI';

const NICKNAME_STORAGE_KEY = 'deskshare_nickname';

function App() {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  // Check for a stored nickname on initial load
  useEffect(() => {
    const storedName = localStorage.getItem(NICKNAME_STORAGE_KEY);
    if (storedName) {
      api.findOrCreateUserByName(storedName).then(user => {
        setCurrentUser(user);
        setIsLoading(false);
      });
    } else {
      setIsLoading(false);
    }
  }, []);

  const handleLogin = useCallback(async (nickname: string) => {
    setIsLoading(true);
    const user = await api.findOrCreateUserByName(nickname);
    localStorage.setItem(NICKNAME_STORAGE_KEY, user.name);
    setCurrentUser(user);
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <NotificationProvider>
        <ConfirmationProvider>
          <AlertProvider> {/* Add the AlertProvider here */}
            {!currentUser ? (
              <LoginOverlay onLogin={handleLogin} />
            ) : (
              <div className="App">
                <DataProvider currentUser={currentUser}>
                  <Header />
                  <main className="main-content">
                      <Routes>
                        <Route path="/" element={<PersonalPage />} />
                        <Route path="/reserve" element={<ReservationPage />} />
                        <Route path="/setup" element={<SetupPage />} />
                      </Routes>
                  </main>
                </DataProvider>
              </div>
            )}
          </AlertProvider>
        </ConfirmationProvider>
      </NotificationProvider>
    </Router>
  );
}

export default App;